import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        bold: {
            fontWeight: 700,
        },
    }
})

export default useStyles
